const axios = require('axios').default;
import { ElLoading } from 'element-plus'
import { showLoading, hideLoading } from './network/request';
var loadingEle;

var endpoint = process.env.VUE_APP_PAYMENT_LAMBDA
// if (process.env.VUE_APP_PAYMENT_LAMBDA === "80") {
//   // endpoint = 'https://zmiz6zzxtv5ug4r4jdled22jg40fpgrj.lambda-url.ap-east-1.on.aws';
// } else if (process.env.VUE_APP_PAYMENT === "68") {
//   endpoint = 'https://ernucrpbq22nqg2bsdypeuoq7i0ltmvw.lambda-url.ap-east-1.on.aws';
// } else {
//   endpoint = 'https://4xhf2j2jic4y2eaet67usmi24i0hftuq.lambda-url.ap-east-1.on.aws';
// }

export var dev_endpoint = endpoint
//env '68' -> matrix.csz618uhxdfr.ap-east-1.rds.amazonaws.com
//env '217' -> matrix-dev.csz618uhxdfr.ap-east-1.rds.amazonaws.com
// export var env = 'bb';
export var env = process.env.VUE_APP_PAYMENT;

//env = '217'

export function loading () {
  // loadingEle = ElLoading.service({
  //   lock: true,
  //   text: 'Loading',
  //   background: 'rgba(0, 0, 0, 0.7)',
  // });
  showLoading()
}

export function closeLoading (loading) {
  console.log("closeLoading")
  //loadingEle.close();
  setTimeout(() => {
    hideLoading();
  }, 200);
}

export async function requestFromAWS (endpoint, action) {
  return axios({
    method: 'post',
    url: endpoint,
    withCredentials: true,
    timeout: 360000,
    data: {
      action: action,
      env: env
    },
  })
    .then(function (response) {
      console.log(response);
      return response;
    })
    .catch(function (error) {
      console.log(error);
    });
}

export async function requestFromAWSWithData (endpoint, action, data) {
  return axios({
    method: 'post',
    url: endpoint,
    withCredentials: true,
    timeout: 360000,
    data: {
      action: action,
      data: data,
      env: env
    },
  })
    .then(function (response) {
      console.log(response);
      return response;
    })
    .catch(function (error) {
      console.log(error);
    });
}

export async function requestFromAWSWithPage (endpoint, action, page) {
  return axios({
    method: 'post',
    url: endpoint,
    withCredentials: true,
    timeout: 360000,
    data: {
      action: action,
      page: page,
      env: env
    },
  })
    .then(function (response) {
      console.log(response);
      return response;
    })
    .catch(function (error) {
      console.log(error);
    });
}

export function getMoneyFormat (data) {
  return data.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

export function getDateFormat (date) {
  var result;
  result = formatDate(date);
  return result;
}
export function getDateFormat2 (date) {
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();

  return `${year}-${month}-${day}`;
}
export function getJSDate (date) {
  if (date instanceof String && date.indexOf('/') != -1) {
    var day = date.split('/')[0];
    var month = date.split('/')[1];
    var year = date.split('/')[2];
    return [month, day, year].join('-');
  } else {
    return date;
  }
}
export function getJSDateForDB (date) {
  if (date.indexOf('/') != -1) {
    var day = date.split('/')[0];
    var month = date.split('/')[1];
    var year = date.split('/')[2];
    return [year, month, day].join('');
  } else {
    return date;
  }
}

function formatDate (date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [day, month, year].join('/');
}


String.prototype.moneyFormatToFloat = function () {
  return parseFloat(this.split('$ ')[1].replace(/,/g, ''));
}

Number.prototype.moneyFormatToFloat = function () {
  return parseFloat(this);
}
